import * as React from "react";
import PropTypes from "prop-types";
import { AppBarIconWrapper } from "nx-components/AppBar";
import { IconHamburgerMenu } from "nx-components/Icons";

export class DrawerRevealerProvider extends React.Component {
  static propTypes = {
    onDrawerRevealerTap: PropTypes.func.isRequired,
    children: PropTypes.node,
  };

  static childContextTypes = {
    handleDrawerRevealerTap: PropTypes.func.isRequired,
  };

  getChildContext() {
    return {
      handleDrawerRevealerTap: () => this.props.onDrawerRevealerTap(),
    };
  }

  render() {
    return this.props.children;
  }
}

export default class DrawerRevealer extends React.Component {
  static contextTypes = {
    handleDrawerRevealerTap: PropTypes.func.isRequired,
  };

  render() {
    return (
      <AppBarIconWrapper
        onTap={this.context.handleDrawerRevealerTap}
        aria-label="Menu"
      >
        <IconHamburgerMenu />
      </AppBarIconWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TopBar/DrawerRevealer.jsx